<template>
    <div class="row pr-4" style="background-color:#fff !important">
        <div class="col-4 text-center" style="height: 100px; display:flex; flex-direction: column; justify-content: center;padding:20px 15px 20px 48px !important;">
            <img :src="companyLogo" class="img"/>
        </div>
        <div class="col-3 pl-4 text-left" style="height: 100px; display:flex; flex-direction: column; justify-content: center;">
            <b>{{ company.fullname }}</b>
            <span style="font-size:11px">{{ company.address }}</span>
        </div>
        <div class="col-2 pl-4 text-left" style="height: 100px; display:flex; flex-direction: column; justify-content: center;">
            <span style="font-size:11px">Telp : {{ company.phone_number }}</span>
            <span style="font-size:11px">{{ company.fax_number ? 'Fax &nbsp;: ' + company.fax_number : '' }}</span>
            <!-- {{ company.email ? 'E-mail: ' + company.email : '' }}<br> -->
        </div>
        <div class="col-3 text-right pr-4" style="height: 100px; display:flex; flex-direction: column; justify-content: center;">
            <b>{{ company.website ? '' + company.website : '' }}</b>
        </div>

        <!-- <div class="col-6 pl-5" style="display:flex; flex-direction: column; justify-content: center;">
            <p class="companyDetails" style="margin-bottom: 5px;font-size:.65rem;">
                
                {{ company.address }}<br>
                
                
                
            </p>
        </div> -->
    </div> 
</template>

<script>
    import env from '@/env'
    export default {
        data () {
            return {
                company : this.$store.state.companyProfile,
                companyLogo : null
            }
        },
        mounted () {
            this.companyLogo = env.baseImage + '/' + this.company.logo_alternate
        },
        methods : {

        }
    }
</script>

<style scoped>

</style>